import { hashString } from 'common/js/utils';
import { useEffect, useRef } from 'react';

export function useMraidListener(
  eventName: 'exposureChange',
  listener: MRAIDExposureChangeListener
): void;
export function useMraidListener(
  eventName: 'stateChange',
  listener: MRAIDStateChangeListener
): void;
export function useMraidListener(
  eventName: 'viewableChange',
  listener: MRAIDViewableChangeListener
): void;
export function useMraidListener(
  eventName: 'ready' | 'ogyOnCloseSystem' | 'ogyOnTouchEnd' | 'ogyOnOpenedUrl',
  listener: () => void
): void;
export function useMraidListener(
  eventName: 'sizeChange',
  listener: MRAIDSizeChangeListener
): void;
export function useMraidListener(
  eventName: 'error',
  listener: MRAIDErrorListener
): void;
export function useMraidListener(
  eventName: 'ogyOnNavigation',
  listener: MRAIDOgyOnNavigationListener
): void;
export function useMraidListener(
  eventName: 'ogyOnOpenedUrl',
  listener: MRAIDOgyOnOpenedUrlListener
): void;
export function useMraidListener(eventName: any, listener: any): void {
  const savedListener = useRef<any>(() => {});

  // If it does not work, move this to useEffect
  const eventListener = (...callbackParams: any[]) =>
    savedListener.current(...callbackParams);

  // adress a special issue on some DSPs
  listener.toString = () => `fct${hashString(String(eventListener))}`;

  useEffect(() => {
    savedListener.current = listener;
  }, []);

  useEffect(() => {
    window.mraid.addEventListener(eventName, eventListener);
    return () => {
      window.mraid.removeEventListener(eventName, eventListener);
    };
  }, []);
}
